import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import { maska } from 'maska';
import 'element-plus/dist/index.css'
import './registerServiceWorker'
require('bootstrap')

createApp(App)
    .use(store)
    .use(router)
    .use(ElementPlus)
    .directive('maska', maska)
    .mount('#app')
